import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=b04fdd40&"
import script from "./AppSidebar.vue?vue&type=script&lang=js&"
export * from "./AppSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports